$(function() {
    $(document).on('click', '.select-tabs .tab-gift', function() {
        console.log('test');
        const parent = $(this).closest('.group-text-gift');

        console.log(parent);
        const input = parent.find('input[type="text"].hidden');
        console.log('input hidden', input);
        $(this).siblings().removeClass('active');
        $(this).addClass('active');
    
        const value = $(this).data('value');
        input.val(value).trigger('input');
    
        if (value === 'otro') {
            const otherContainer = parent.find('.other-container');
            if (!otherContainer.hasClass('active')) {
                otherContainer.addClass('active');
            }
        } else {
            const otherContainer = parent.find('.other-container');
            if (otherContainer.hasClass('active')) {
                otherContainer.removeClass('active');
            }
        }
    });
    
    let timeoutClean;
    $(document).on('change', '#gift-global', function() {
        if (timeoutClean) {
            clearTimeout(timeoutClean);
        }
        const isChecked = $(this).is(':checked');
        const allGiftContainers = $('.cart-item-page-gift.normal-item');

        if (isChecked) {
            allGiftContainers.addClass('checked');
            // Enable hidden inputs so they get submitted
            $('.input-gift-property').prop('disabled', false);
        } else {
            allGiftContainers.removeClass('checked');
            // Disable hidden inputs so they don't get submitted
            $('.input-gift-property').prop('disabled', true);

            // Reset all inputs within the gift containers
            timeoutClean = setTimeout(() => {
                allGiftContainers.find('input[type="text"], textarea').val('');
                allGiftContainers.find('.select-tabs .tab-gift').removeClass('active');
                allGiftContainers.find('.other-container').removeClass('active');
            }, 500);
        }
    });


    var hiddenDateInput = document.getElementById('delivery-date-hidden');

    var tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1); 

    const fechaInput = document.getElementById('fechaEntrega');
    fechaInput.addEventListener('keydown', function (event) {
        if (event.key === 'Delete' || event.key === 'Backspace') {
            event.preventDefault(); // Prevent default behavior
            // Optionally, you can clear the input manually or show a message
            this.value = ''; // Clear the input
        }
    });

    const minDate = new Date();
    minDate.setDate(minDate.getDate() + (minDate.getHours() >= 14 ? 2 : 1));

    var startPicker = new Pikaday({
        field: document.getElementById('fechaEntrega'),
        container: document.getElementById('container-fechaEntrega'),
        minDate: minDate,
        bound: true,
        format: 'YYYY-MM-DD',
        disableDayFn: function(date) {
            const allowWeekends = $('#fechaEntrega').data('allow-weekends');
            if (allowWeekends === true || allowWeekends === 'true') {
                return false;
            }
            // 0 is Sunday, 6 is Saturday
            return date.getDay() === 0 || date.getDay() === 6;
        },
        toString: function(date) {
            const day = date.getDate();
            const monthNames = ['ENERO','FEBRERO','MARZO','ABRIL','MAYO','JUNIO','JULIO','AGOSTO','SEPTIEMBRE','OCTUBRE','NOVIEMBRE','DICIEMBRE'];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear();
            return `${day} ${month} ${year}`;
        },
        onSelect: function(date) {
            const day = date.getDate();
            const monthNames = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            const month = monthNames[date.getMonth()];
            const year = date.getFullYear().toString().slice(-2);
            const friendlyDate = `${day}/${month}/${year}`;

            const formatted = startPicker.toString(date);

            updateCartAttributes(friendlyDate, document.getElementById('time-input').value);        
            document.getElementById('fechaEntrega').value = formatted;
            $('.custom-date-wrapper').removeClass('show');
        },
        i18n: {
            previousMonth : '',
            nextMonth     : '',
            months        : ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
            weekdays      : ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
            weekdaysShort : ['D','L','M','X','J','V','S']
        }
    });
    $(document).on('click', '.custom-date-wrapper', function(e) {
        $(this).toggleClass('show');
    });

   

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.custom-date-wrapper').length) {
            $('.custom-date-wrapper').removeClass('show');
        }
    });

    $(document).on('click', '.custom-select-wrapper .custom-select', function(e) {
        $(this).parent().toggleClass('show');
    });

    $(document).on('click', function(e) {
        if (!$(e.target).closest('.custom-select-wrapper').length) {
            if ($('.custom-select-wrapper').hasClass('show')) {
                $('.custom-select-wrapper').removeClass('show');
            }
        }
    });    



});

